import { Field } from "enums";

export const alertFormState = {
  alerts: { type: Field.ANY, value: [{ value: "none" }], validations: [] },
};
